import { render, staticRenderFns } from "./TariffBenDetail.vue?vue&type=template&id=f328fd6a&"
import script from "./TariffBenDetail.vue?vue&type=script&lang=js&"
export * from "./TariffBenDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports